import store from '@/store/index';
import { plansof } from '@/utils/chain';
import { ALLOW_MIXED_BUY_FREE_TRIAL_PLANS } from '../constants';

export const isSelectedPlanMixedFreeTrial = () => {
  const getSelectedPlans = store.getters.getSelectedPlans
  return plansof(getSelectedPlans).freeTrial().has() &&
    plansof(getSelectedPlans).not().freeTrial().has() &&
    plansof(getSelectedPlans) &&
    plansof(getSelectedPlans).type(...ALLOW_MIXED_BUY_FREE_TRIAL_PLANS).has()
}

export const filterOutFreeTrialPayloads = (payloads) => {
  if (payloads && payloads.length !== undefined) {
    return payloads?.filter(item => !item.trialCode)
  } else {
    return payloads
  }
}